        /* Deferred popup imagery.
           The overlay is position:fixed and only visibility:hidden, so the browser
           treats its images as in-viewport and downloads them on page load even with
           loading="lazy". Holding the URLs in data-src and swapping them in when the
           popup is actually opened keeps ~1 MB off first paint. */
        (function () {
          function hydrate(popup) {
            if (!popup || popup.dataset.imagesLoaded) return;
            popup.dataset.imagesLoaded = '1';
            popup.querySelectorAll('img[data-src]').forEach(function (img) {
              if (img.dataset.srcset) {
                img.setAttribute('srcset', img.dataset.srcset);
                delete img.dataset.srcset;
              }
              img.setAttribute('src', img.dataset.src);
              img.removeAttribute('loading');
              img.setAttribute('fetchpriority', 'high');
              delete img.dataset.src;
            });
          }

          function watch(popup) {
            if (popup.classList.contains('active')) hydrate(popup);
            new MutationObserver(function () {
              if (popup.classList.contains('active')) hydrate(popup);
            }).observe(popup, { attributes: true, attributeFilter: ['class'] });
          }

          function init() {
            document.querySelectorAll('.popup-overlay').forEach(watch);
          }

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
          } else {
            init();
          }
        })();

        $(document).ready(function() {
                 
          $('body').on('click','a[href="#maintenance"]',function(e) {
                 e.preventDefault();
                 var text = 'Maintenance Plan';
                $('.popup-overlay[popup-text="' + text + '"]').addClass('active');
                $('body, html').css('overflow-y', 'hidden');
               });
                                $('body').on('click', 'a[href="#virtual-pop"]', function(e) {
                        e.preventDefault();
                var text = 'Virtual Stylist';
                $('.popup-overlay[popup-text="' + text + '"]').addClass('active');
                $('body, html').css('overflow-y', 'hidden');
            });
                      $('body').on('click', '.klarna-button', function(e) {
                        e.preventDefault();
                var text = 'Afterpay';
                        if ( $('.popup-overlay[popup-text="' + text + '"]').length > 0) {
                $('.popup-overlay[popup-text="' + text + '"]').addClass('active');
                $('body, html').css('overflow-y', 'hidden');
                        }
            });
            $('body').on('click', '.multicolumn-v5 .multicolumn-list__item', function() {
                var text = $(this).text().trim();
                console.log('clicked this text ' + text);
                if ( $('.popup-overlay[popup-text="' + text + '"]').length > 0) {
                $('.popup-overlay[popup-text="' + text + '"]').addClass('active');
                $('body, html').css('overflow-y', 'hidden');
                }
            });

            $('body').on('click', '#popupClose, #popUpCloseButton', function() {
                $(this).closest('.popup-overlay').removeClass('active');
                $('body, html').css('overflow-y', 'auto');
            });
          $('body').on('click','div[popup-text="Virtual Stylist"] a',function() {
            $(this).closest('.popup-overlay').removeClass('active');
             $('body, html').css('overflow-y', 'auto');
          });

          function openAuthorsie(text){
                        var popup = document.querySelector('.popup-overlay[popup-text="' + text + '"]');
                        if (popup) {
                        popup.classList.add('active');
                        document.body.style.overflowY = 'hidden';
                        document.documentElement.style.overflowY = 'hidden';
                        }
          }


                


                document.querySelectorAll(".AuthorizedDealer").forEach(function(a){
                        a.addEventListener("click", function(){
                                var item = document.querySelectorAll(".multicolumn-v5 .multicolumn-list__item")[3];
                                var text = item.textContent.trim();
                                openAuthorsie(text)
                        })
                })

        });

